import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import { EquipmentModel } from '../models/EquipmentModel';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as myCfg from '../AppConfig';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface EquipmentList {
    items: EquipmentModel[];
    loading: boolean;
}

export interface EquipmentRetrieve { type: 'EQUIPMENT_CALL_LOAD', newState: EquipmentList }
export interface EquipmentLoading { type: 'EQUIPMENT_LOADING' }

export type KnownAction = EquipmentRetrieve | EquipmentLoading | ResetStore;

const initialCallListState: EquipmentList = {
    items: [],
    loading: false
};

export const actionCreators = {
    loadEquipments: (pSession: SessionModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //const appState = getState().sessionState.      
        var ServiceMasterNumber = pSession.SelectedSM.id;
        var CompanyCode = pSession.SelectedAR.companyCode;        
        dispatch({ type: 'EQUIPMENT_LOADING' });
        //EquipmentFrom, String CompanyCode, String Source1, String Source2
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/Equipment?EquipmentFrom=SM&Source1=' + ServiceMasterNumber + '&CompanyCode=' + CompanyCode,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                if (container.success) {
                    const data: EquipmentModel[] = container.data;
                    dispatch({ type: 'EQUIPMENT_CALL_LOAD', newState: { items: data, loading: false } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });

    },
    loadEquipmentsForContract: (contractNumber :string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;

        var ServiceMasterNumber = sessionState.SelectedSM.id;
        var CompanyCode = sessionState.SelectedAR.companyCode;
        dispatch({ type: 'EQUIPMENT_LOADING' });
        //EquipmentFrom, String CompanyCode, String Source1, String Source2
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/Equipment?EquipmentFrom=CON&Source1=' + ServiceMasterNumber + '&Source2=' + contractNumber  + '&CompanyCode=' + CompanyCode,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                if (container.success) {
                const data: EquipmentModel[] = container.data;
                    dispatch({ type: 'EQUIPMENT_CALL_LOAD', newState: { items: data, loading: false } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });

    }
};


export const reducer: Reducer<EquipmentList> = (state: EquipmentList | undefined, incomingAction: Action): EquipmentList => {

    if (state === undefined) {        
        return { ...initialCallListState };
    }
    const action = incomingAction as KnownAction;

    switch (action.type) {
        case 'EQUIPMENT_LOADING':                        
            return {
                ...state, loading: true
            };
        case 'EQUIPMENT_CALL_LOAD':            
            const loadEqpAction = incomingAction as EquipmentRetrieve;
            return loadEqpAction.newState;
        case 'STORE_RESET':
            return { ...initialCallListState };
        default:
            return state;
    }
}; 